const PATH = 'fe.components.learning_resources.filter_sidebar';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: 'Learner Preferences'
  },
  description: {
    key: `${PATH}.description`,
    defaultValue:
      'Choose your preferred settings to tailor your learning experience.'
  },
  search: {
    key: `${PATH}.search`,
    defaultValue: 'Search'
  },
  searchPlaceholder: {
    key: `${PATH}.search_placeholder`,
    defaultValue: 'Search All Resources'
  },
  classVersion: {
    key: `${PATH}.class_version`,
    defaultValue: 'CLASS Version'
  },
  ageLevels: {
    key: `${PATH}.age_levels`,
    defaultValue: 'Age Level(s)'
  },
  dimensions: {
    key: `${PATH}.dimensions`,
    defaultValue: 'Dimension(s)'
  },
  dimensionsPlaceholder: {
    key: `${PATH}.dimensions_placeholder`,
    defaultValue: 'Select a Dimension'
  },
  resourceType: {
    key: `${PATH}.resource_type`,
    defaultValue: 'Resource Type'
  },
  resourceTypePlaceholder: {
    key: `${PATH}.resource_type_placeholder`,
    defaultValue: 'Select a Resource Type'
  },
  language: {
    key: `${PATH}.language`,
    defaultValue: 'Language'
  },
  clearFilters: {
    key: `${PATH}.clear_filters`,
    defaultValue: 'Clear Filters'
  }
};

export default messages;
